import { Box, IconButton, Popover } from '@mui/material';
import { alpha } from '@mui/material/styles';
import Tooltip from '@mui/material/Tooltip';
import type React from 'react';
import { memo } from 'react';

import { borderRadius, boxShadows, palette, spaces } from '../../../../assets/styles/themes/tokens';
import ColorPicker from '../ColorPicker';

interface ColorPickerMenuProps {
	id: string;
	icon: React.JSX.Element;
	handleClick: (event: React.MouseEvent<HTMLElement>) => void;
	handleClose: () => void;
	onChangeColor: (color: string) => void;
	onClearColor: () => void;
	anchorEl: HTMLElement | null;
	dataTestId: string;
	currentColor?: string;
}

const ColorPickerMenu: React.FC<ColorPickerMenuProps> = (props) => {
	const {
		id,
		icon,
		handleClick,
		handleClose,
		onChangeColor,
		onClearColor,
		anchorEl,
		currentColor,
		dataTestId,
	} = props;
	const isAnchorElOpen = Boolean(anchorEl);
	const popoverId = isAnchorElOpen ? id : undefined;

	return (
		<>
			<Tooltip title={id} leaveDelay={0} leaveTouchDelay={0}>
				<IconButton
					data-testid={`${dataTestId}-button`}
					color="secondary"
					size="small"
					onClick={handleClick}
					sx={{
						backgroundColor: currentColor ? alpha(palette.primary.main, 0.08) : 'transparent',
						'&:hover': {
							backgroundColor: currentColor
								? alpha(palette.primary.main, 0.08)
								: alpha(palette.primary.main, 0.06),
						},
					}}
				>
					{icon}
				</IconButton>
			</Tooltip>
			<Popover
				data-testid={dataTestId}
				id={popoverId}
				open={isAnchorElOpen}
				anchorEl={anchorEl}
				onClose={handleClose}
				sx={{
					zIndex: 1500,
				}}
				PaperProps={{
					style: {
						zIndex: 1500,
						overflow: 'visible',
						boxShadow: boxShadows.elevation8,
						borderRadius: borderRadius.xs,
					},
				}}
				anchorOrigin={{
					vertical: 'bottom',
					horizontal: 'left',
				}}
			>
				<Box
					sx={{
						padding: spaces.xxs,
					}}
				>
					<ColorPicker color={currentColor} onChange={onChangeColor} onClear={onClearColor} />
				</Box>
			</Popover>
		</>
	);
};

export default memo(ColorPickerMenu);
